export const CISPE_COMPLIANCE_MESSAGE = "AWS prohibits unauthorized access by AWS personnel to Customer Content for any purpose. You should only access Customer Content if the access is needed and you have received and recorded customer consent or are physically located in an EEA country. If access to a resource is needed, but you are not physically located in an EEA country or have not received and recorded customer consent, you must not perform actions on the resource that could display Customer Content."
export const CISPE_EMPTY_FIELD_WARNING = "To view raw logs, ticket and description fields cannot be empty!"
export const DISCLOSURE_MESSAGE = "Please do not share any Amazon Proprietary Information including IP addresses, internal namespace etc to the customer!"
export const DEFAULT_SORTING_METRIC = 'shard_heap_allocated'
export const NODES_DEFAULT_SORTING_METRIC = 'heap_max'
export const DEFAULT_FILTERS = { period: '5', statistics: 'avg' }
export const NON_SORTING_METRICS = ['p50', 'p75', 'p90', 'p99']
export const clusterInsightsDisabledVfis = [
    "OpenSearch_2_19_R20250630-P1",
    "OpenSearch_2_19_R20250630",
    "OpenSearch_2_19_R20250630-P2",
    "OpenSearch_2_19_R20250630-P4",
    "OpenSearch_2_19_R20250428",
    "OpenSearch_2_19_R20250920",
    "OpenSearch_2_19_R20250630-P3",
    "OpenSearch_2_19_R20250903",
    "OpenSearch_2_19_R20250625",
    "OpenSearch_2_19_R20250630-P5",
    "OpenSearch_2_17_R20250630",
    "OpenSearch_2_17_R20250625",
    "OpenSearch_2_17_R20241112-P3",
    "OpenSearch_2_17_R20250920",
    "OpenSearch_2_17_R20250403",
    "OpenSearch_2_17_R20241112",
    "OpenSearch_2_17_R20241111",
    "OpenSearch_2_17_R20241112-P2",
    "OpenSearch_2_17_R20241112-P5",
    "OpenSearch_2_17_R20241112-P1",
    "OpenSearch_2_17_R20250319",
    "OpenSearch_2_17_R20250630-P2",
    "OpenSearch_2_17_R20241112-P4",
    "OpenSearch_2_17_R20250630-P1"
]
